import OpportuniteClient from '@/components/opportuniteClient/App';
import ErrorPage from '@/components/opportuniteClient/errorPage';
import Accueil from '@/components/opportuniteClient/Accueil';

export default [
  {
    path: '/opportunite-client/:id',
    component: OpportuniteClient,
  },
  {
    path: '/',
    component: Accueil,
  },
  {
    path: '/error-page',
    component: ErrorPage,
  },
  {
    path: '*',
    redirect: '/',
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js